module.exports = {"object":"value","document":{"object":"document","nodes":[{"object":"block","type":"title","nodes":[{"object":"text","text":"Enforce Your Layout!"}]},{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"This example shows how to enforce your layout with schema-specific rules. This document will always have a title block at the top and at least one paragraph in the body. Try deleting them and see what happens!"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./examples/forced-layout/value.json
// module id = 764
// module chunks = 0